import { httpRequest } from "../../http.ts"

interface UpdateKeyDatePayload {
  key_date_type_id?: number | null
  label?: string | null
  date: string | null
}

export class CommandUpdateKeyDates {
  async run(
    engagementId: number,
    objectiveId: string,
    keyDateId: number,
    payload: UpdateKeyDatePayload
  ) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/objectives/${objectiveId}/key-dates/${keyDateId}/`
    try {
      const response = await httpRequest<any>(url, {
        method: "PUT",
        body: payload,
      })
      return response
    } catch (error) {
      console.error("Error fetching data:", error)
      throw error
    }
  }
}
